export const ACCESS_DENIED_STATUS_CODES = [401, 403];
